import { ConnectionState, DisconnectReason } from "livekit-client";

export type FreshReconnectDecisionInput = {
  isRecording: boolean;
  reason?: DisconnectReason;
  retryCount: number;
  maxRetries: number;
  roomState?: ConnectionState | null;
  isConnecting: boolean;
  isFreshReconnectInProgress: boolean;
};

export function isExpectedDisconnect(reason?: DisconnectReason): boolean {
  return (
    reason === DisconnectReason.CLIENT_INITIATED || reason === DisconnectReason.DUPLICATE_IDENTITY
  );
}

export function isFinalDisconnectedState(state?: ConnectionState | null): boolean {
  return !state || state === ConnectionState.Disconnected;
}

export function shouldScheduleFreshReconnect({
  isRecording,
  reason,
  retryCount,
  maxRetries,
  roomState,
  isConnecting,
  isFreshReconnectInProgress,
}: FreshReconnectDecisionInput): boolean {
  if (!isRecording) return false;
  if (isExpectedDisconnect(reason)) return false;
  if (retryCount >= maxRetries) return false;
  if (isConnecting || isFreshReconnectInProgress) return false;

  return isFinalDisconnectedState(roomState);
}
